// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcc35970","609":"4be12661","625":"95ee1329","649":"d0a4a1d3","652":"646f2673","674":"f7cbb0d9","863":"cddea1e2","872":"aa8b73b2","900":"5f89728a"}[chunkId] + ".chunk.js";
};